import * as React from 'react';

import { Paper, lighten, Color, PaperProps } from '@mui/material';

import useIsMobile from '../core/hooks/useIsMobile';
import { getColor } from '../core/colors';

interface IFormPaper {
  children: React.ReactNode;
  color: string | Color | null | undefined;
  paperProps?: PaperProps;
}

function FormPaper({ children, color, paperProps }: IFormPaper) {
  const isMobile = useIsMobile();
  const lightenedColor = typeof color === 'string' || typeof color === 'undefined' || color === null
    ? lighten(getColor(color)[200], 0.8)
    : lighten(color[200], 0.8);

  return (
    <Paper
      sx={{
        padding: isMobile ? 1 : 2,
        mb: 2,
        backgroundColor: lightenedColor,
      }}
      {...paperProps}
    >
      {children}
    </Paper>
  );
}

export default FormPaper;
